<template>
  <div>
    <div
      v-for="(value, index) in schemeLabels"
      :key="index"
      class="scheme-form__colorLabels"
    >
      <div class="scheme-form__labels-wrapper">
        <div
          :style="{ backgroundColor: addColor(index) }"
          class="scheme-form__color"
        ></div>
        {{ value.key }}
      </div>
      <span @click="deleteValue(index)" class="scheme-form__color-delete"
        >x</span
      >
    </div>
    <div class="scheme-form__labels-container">
      <fg-input
        @keyup.native="enterValueToSheme"
        :disabled="schemeType === ''"
        v-model="valueInput"
      ></fg-input>
      <p-button
        size="sm"
        style="line-height: 2.4; position: absolute; top: 0; right:0"
        @click.native="addValueToSheme"
        >Add</p-button
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      valueInput: "",
      colorCache: {},
      defaultColors: [
        "ff0029",
        "377eb8",
        "66a61e",
        "984ea3",
        "00d2d5",
        "ff7f00",
        "af8d00",
        "7f80cd",
        "b3e900",
        "c42e60",
        "a65628",
        "f781bf",
        "8dd3c7",
        "bebada",
        "fb8072",
        "80b1d3",
        "fdb462",
        "fccde5",
        "bc80bd",
        "ffed6f",
        "c4eaff",
        "cf8c00",
        "1b9e77",
        "d95f02",
        "e7298a",
        "e6ab02",
        "a6761d",
        "0097ff",
        "00d067",
        "000000",
        "252525",
        "525252",
        "737373",
        "969696",
        "bdbdbd",
        "f43600",
        "4ba93b",
        "5779bb",
        "927acc",
        "97ee3f",
        "bf3947",
        "9f5b00",
        "f48758",
        "8caed6",
        "f2b94f",
        "eff26e",
        "e43872",
        "d9b100",
        "9d7a00",
        "698cff",
        "d9d9d9",
        "00d27e",
        "d06800",
        "009f82",
        "c49200",
        "cbe8ff",
        "fecddf",
        "c27eb6",
        "8cd2ce",
        "c4b8d9",
        "f883b0",
        "a49100",
        "f48800",
        "27d0df",
        "a04a9b"
      ]
    };
  },
  props: {
    bordered: {
      type: Boolean
    }
  },
  computed: {
    schemeLabels() {
      return this.$store.getters.getSchemeLabels;
    },
    schemeType() {
      return this.$store.getters.getSchemeType;
    }
  },
  methods: {
    addValueToSheme() {
      if (this.valueInput === "") {
        return;
      }
      const labelColor = "#" + this.defaultColors[this.schemeLabels.length];
      this.$store.dispatch("addSchemeLabel", {
        key: this.valueInput,
        value: labelColor
      });
      this.valueInput = "";
    },
    enterValueToSheme(e) {
      if (e.keyCode === 13) {
        this.addValueToSheme();
      }
    },
    addColor(index) {
      if (index >= this.defaultColors.length - 1) {
        return "#" + this.defaultColors[index - this.defaultColors.length - 1];
      }
      return "#" + this.defaultColors[index];
    },
    deleteValue(index) {
      this.$store.dispatch("removeSchemeLabel", index);
    }
  }
};
</script>
<style lang="scss">
.scheme-section {
  &__title {
    border-bottom: 1px solid #dddddd;
    font-size: 20px;
    padding: 5px 0px;
  }
}

.scheme-form {
  text-align: center;

  &__labels-wrapper {
    display: flex;
  }

  &__colorLabels {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    font-weight: bold;
  }

  &__color {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 10px;
  }

  &__color-delete {
    cursor: pointer;
  }

  &__labels-container {
    position: relative;
  }
}
</style>
